/**
 * 账号字符规则。
 * 用户名：不能为空、不能含空格，最长仍由各表单限制为 20 位。
 * 允许中文、字母、数字，以及 . _ - ·。
 * 密码：只要有内容即可，不限制最短长度和字符组合；最长 20 位仍由各表单限制。
 */

const USERNAME_PATTERN = /^[\u4e00-\u9fffA-Za-z0-9._\-\u00B7]+$/

export const USERNAME_FORMAT_MESSAGE = '账号只能包含中文、字母、数字，以及 . _ - ·'
export const USERNAME_SPACE_MESSAGE = '账号不能包含空格'

export function getUsernameFormatError(username) {
  if (/\s/.test(username)) {
    return USERNAME_SPACE_MESSAGE
  }
  if (!USERNAME_PATTERN.test(username)) {
    return USERNAME_FORMAT_MESSAGE
  }
  return ''
}
